// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.single-modal-body {
  position: absolute;
  top: 40%;
  width: auto;
  background-color: #0D0D0D;
  border-radius: .5vw;
  padding: .25vw;
  outline: none;
  border: none;
}
`, "",{"version":3,"sources":["webpack://./src/components/ui/modals/singleModal/singleModal.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,QAAQ;EACR,WAAW;EACX,yBAAyB;EACzB,mBAAmB;EACnB,cAAc;EACd,aAAa;EACb,YAAY;AACd","sourcesContent":[".single-modal-body {\n  position: absolute;\n  top: 40%;\n  width: auto;\n  background-color: #0D0D0D;\n  border-radius: .5vw;\n  padding: .25vw;\n  outline: none;\n  border: none;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
